import { ServiceFetch } from '../service-fetch'

export default class CompanyInfoModel extends ServiceFetch {
    getCompanyInfo = (data) => this.authFetch({
        url: 'company-info/getCompanyInfo',
        method: 'POST',
        body: JSON.stringify(data),
    })
}